import { mapActions } from 'vuex'

export const steps_create_mission_perf_analysis = [
  {
    target: '[gt_PerformanceAnalysis-v-step="1"]',
    content:
      'Click on <strong>Select</strong> to see all missions in the constellation module.',
    params: {
      placement: 'bottom'
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="2"]',
    content: 'Click on <strong>Select</strong> to pick a Performance Analysis.',
    params: {
      placement: 'bottom'
    }
  }
]
export const defaultValueMission = [
  'Constellation performance analysis test',
  10
]
export const steps_perf_analysis_mission = [
  {
    target: '[gt_PerformanceAnalysis-v-step="3"]',
    content: 'Firstly, give a name to your mission.',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="4"]',
    content:
      'Now click on the constellation field and select <strong>create new constellation</strong>.',
    params: {
      placement: 'right-end',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="38"]',
    content: 'Your mission now contains the created constellation.',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="39"]',
    content:
      'On the Earth mesh field select <strong>create new earth mesh</strong>.',
    params: {
      placement: 'right-end',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="48"]',
    content: 'Your mission now contains the created earth mesh.',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="49"]',
    content: 'Set the simulation duration to 10 days.',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="50"]',
    content:
      'Keep the option <strong>Revisit</strong> and select <strong> Ground segment simplified</strong>.',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="51"]',
    content:
      'In the ground stations field, select stations <strong>Aracaju</strong>, <strong>Auckland</strong> and <strong>Bogota</strong>.',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="52"]',
    content:
      'Leave all other values to their default value and click <strong>Save</strong>.'
  }
]
export const defaultValueConstellation = ['Constellation use case']
export const steps_constellation = [
  {
    target: '[gt_PerformanceAnalysis-v-step="5"]',
    content: 'Give a <strong>Name</strong> to your constellation.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="6"]',
    content:
      'Now click on the <strong>Constellation homogeneous geometries</strong> field and select <strong>Create new constellation homogeneous geometries</strong>.',
    params: {
      placement: 'right-end',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="25"]',
    content:
      'Your constellation now contains the created homogeneous geometry.',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="26"]',
    content:
      'Click on the <strong>Constellation homogeneous geometries</strong> field again and select <strong>Create new constellation homogeneous geometries</strong> once more.',
    params: {
      placement: 'right-end',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="37"]',
    content:
      'Your constellation now contains both created homogeneous geometries, <strong>Save</strong> your constellation.',
    params: {
      enableScrolling: false
    }
  }
]
export const defaultValueConstellationGeometry = [
  'Constellation geometry 1',
  60,
  30,
  5,
  0,
  800,
  0,
  'Constellation geometry 2',
  20,
  4,
  0,
  600
]
export const steps_constellation_geometry = [
  {
    target: '[gt_PerformanceAnalysis-v-step="7"]',
    content: 'Give a <strong>Name</strong> to your constellation geometry.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="8"]',
    content:
      'Now click on the <strong>Payload</strong> field and select <strong>Create new payload</strong>.',
    params: {
      placement: 'right-end',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="15"]',
    content:
      'Set Constellation definition type to <strong>Walker-Delta</strong>.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="16"]',
    content:
      'For more information about this type of constellation, click on this question mark.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="17"]',
    content:
      'Set Orbit definition to <strong>Altitude and inclination</strong>.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="18"]',
    content: 'Set <strong>inclination</strong> to 60.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="19"]',
    content: 'Set <strong>total number of spacecrafts</strong> (t) to 30.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="20"]',
    content: 'Set <strong>number of orbital planes</strong> (p) to 5.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="21"]',
    content: 'Set <strong>inter-plane phasing coefficient</strong> (f) to 0.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="22"]',
    content: 'Set <strong>Altitude</strong> to 800km.',
    params: {
      placement: 'bottom'
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="23"]',
    content: 'Set <strong>First plane initial RAAN</strong> to 0.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="24"]',
    content:
      'Leave other fields to their default values and click on <strong>Create</strong>.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="27"]',
    content: 'Give a <strong>Name</strong> to your constellation geometry.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="28"]',
    content:
      'Now click on the <strong>Payload</strong> field and select the previously created payload.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="29"]',
    content:
      'Set Constellation definition type to <strong>Walker-Delta</strong>.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="30"]',
    content:
      'Set Orbit definition to <strong>Altitude and Sun-synchronous</strong>.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="31"]',
    content: 'Set <strong>total number of spacecrafts</strong> (t) to 20.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="32"]',
    content: 'Set <strong>number of orbital planes</strong> (p) to 4.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="33"]',
    content: 'Set <strong>inter-plane phasing coefficient</strong> (f) to 0.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="34"]',
    content: 'Set <strong>Altitude</strong> to 600km.',
    params: {
      placement: 'bottom'
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="35"]',
    content: 'Set <strong>First plane inital RAAN</strong> to 0.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="36"]',
    content:
      'Leave other fields to their default values and click on <strong>Create</strong>.',
    params: {
      placement: 'bottom',
      enableScrolling: false
    }
  }
]

export const defaultValueEarthMesh = ['World Mesh', -180, 180, -80, 80, 20, 20]
export const steps_earth_mesh = [
  {
    target: '[gt_PerformanceAnalysis-v-step="40"]',
    content: 'Give a name to your mesh (ex: World Mesh)',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="41"]',
    content: 'Select mesh definition type <strong>Number</strong>.',
    params: {
      placement: 'right-end',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="42"]',
    content: 'Select mesh element definition <strong>Constant step</strong>.',
    params: {
      placement: 'right-end',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="43"]',
    content: 'Set West to -180° and East to 180°.',
    params: {
      placement: 'right-end',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="44"]',
    content: 'Set South to -80° and North to 80°.',
    params: {
      placement: 'right-end',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="45"]',
    content: 'Set Number of longitudes to 20 and Number of latitudes to 20.',
    params: {
      placement: 'right-end',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="46"]',
    content: 'You can see on the right a visualization of this mesh.',
    params: {
      placement: 'right-end',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="47"]',
    content: 'Click on <strong>Create</strong>.',
    params: {
      enableScrolling: false
    }
  }
]

export const defaultValuePayload = ['Payload use case', 5, 20, 25]
export const steps_payload = [
  {
    target: '[gt_PerformanceAnalysis-v-step="9"]',
    content: 'Give a name to your payload (ex:Payload use case).',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="10"]',
    content: 'Set nominal power to 5W.',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="11"]',
    content: 'Set semi-view angle to 20°.',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="12"]',
    content: 'Set telecom properties to defined.',
    params: {
      enableScrolling: false,
      placement: 'right-end'
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="13"]',
    content: 'Set uplink rate to 20 MB/s.',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="14"]',
    content: 'Click on <strong>Create</strong> to save your payload.',
    params: {
      placement: 'top'
    }
  }
]
export const steps_performance_analysis_dashboard = [
  {
    target: '[gt_PerformanceAnalysis-v-step="53"]',
    content: 'Click on <strong>Start computation</strong> to see the results.',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="54"]',
    content:
      'In this pannel here, you can choose the category of information you wish to visualize.',
    params: {
      enableScrolling: false,
      placement: 'right-end'
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="55"]',
    content:
      'In this second pannel, you can choose which particular value you wish to put into evidence.',
    params: {
      enableScrolling: false,
      placement: 'right-end'
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="56"]',
    content:
      'Once you have selected the parameters you wish to see, you can click on <strong>Update Map</strong>. This will update all the visualizations',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="57"]',
    content:
      'Click on this button to see other ways to customize this dashboard.',
    params: {
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="58"]',
    content:
      'As you can see, one can choose to show only a particular range of values.'
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="59"]',
    content:
      'Maps can be removed from the dashboard and the colorscale can be changed.'
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="60"]',
    content:
      'Timelines, statistics and histograms can also be removed from the dashboard.'
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="61"]',
    content:
      'If you are satisfied with your display settings, click on <strong>Update Map</strong>.'
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="62"]',
    content:
      'On this map, one can choose to visualize the mesh (show rectangles in the display options), the satellites traces and the ground stations selected. ',
    params: {
      enableScrolling: false,
      placement: 'right-end'
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="63"]',
    content:
      'If you click on the map, you will see the single point results update. ',
    param: {
      placement: 'bottom',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="64"]',
    content:
      'You can also update them by setting specific longitude and latitude coordinates in here and clicking on <strong>Update coordinates</strong>. ',
    param: {
      placement: 'right-end',
      enableScrolling: false
    }
  },
  {
    target: '[gt_PerformanceAnalysis-v-step="65"]',
    content: 'Congratulations ! You have finished this tutorial.'
  }
]
export default {
  ...mapActions(['start_gt_PerformanceAnalysis']),
  setDefaultTourValue(component, list, field, index) {
    component.inputs[field] =
      component.inputs[field] === '' || component.inputs[field] == null
        ? list[index]
        : component.inputs[field]
  },

  onSkipCreateMission(component) {
    component.redirectToConstellation()
  },

  beginPerformanceAnalysisTour(component) {
    if (component.gt_PerformanceAnalysis.earthMeshDone) {
      component.$tours['performanceAnalysisTourMission'].start(4)
    } else if (component.gt_PerformanceAnalysis.secondGeometryDone) {
      component.$tours['performanceAnalysisTourMission'].start(2)
    } else {
      component.$tours['performanceAnalysisTourMission'].start()
    }
  },
  onNextStepPerfAnalysisMission(currentStep, component) {
    switch (currentStep) {
      case 0:
        this.setDefaultTourValue(component, defaultValueMission, 'name', 0)
        break
      case 1:
        if (component.inputs.constellation === null) {
          component.$tours['performanceAnalysisTourMission'].start(1)
        } else {
          component.gt_PerformanceAnalysis.firstGeometryDone = true
          component.gt_PerformanceAnalysis.firstPayloadDone = true
        }
        break
      case 3:
        if (component.inputs.earthMesh === null) {
          component.$tours['performanceAnalysisTourMission'].start(3)
        } else {
          component.gt_PerformanceAnalysis.earthMeshDone = true
        }
        break
      case 5:
        this.setDefaultTourValue(
          component,
          defaultValueMission,
          'simulationDuration',
          1
        )
        break
      case 6:
        if (component.inputs.computeSimplifiedGroundSegment === false) {
          component.inputs.computeSimplifiedGroundSegment = true
        }
        break
      case 7:
        if (component.inputs.groundStations === null) {
          component.$tours['performanceAnalysisTourMission'].start(7)
        }
        break
      default:
        break
    }
  },

  beginConstellationTour(component) {
    const tourName = 'performanceAnalysisTourConstellationHeterogeneous'
    if (component.gt_PerformanceAnalysis.secondGeometryDone) {
      component.$tours[tourName].start(4)
    } else if (component.gt_PerformanceAnalysis.firstGeometryDone) {
      component.$tours[tourName].start(2)
    } else {
      setTimeout(() => component.$tours[tourName].start(), 500)
    }
  },

  onNextStepConstellation(currentStep, component) {
    const tourName = 'performanceAnalysisTourConstellationHeterogeneous'
    if (currentStep === 0) {
      this.setDefaultTourValue(component, defaultValueConstellation, 'name', 0)
    } else if (currentStep === 1) {
      if (
        component.inputs.homogeneousConstellationGeometries === null ||
        component.inputs.homogeneousConstellationGeometries.length === 0
      ) {
        component.$tours[tourName].start(1)
      } else {
        component.gt_PerformanceAnalysis.firstGeometryDone = true
        component.gt_PerformanceAnalysis.firstPayloadDone = true
      }
    } else if (currentStep === 3) {
      if (component.inputs.homogeneousConstellationGeometries.length < 2) {
        component.$tours[tourName].start(3)
      }
    }
  },

  onNextStepEarthMesh(currentStep, component) {
    switch (currentStep) {
      case 0:
        this.setDefaultTourValue(component, defaultValueEarthMesh, 'name', 0)
        break
      case 1:
        component.inputs['rangeType'] = 'NUMBER'
        break
      case 2:
        component.inputs['elementDefinition'] =
          component.getDefaultValue('elementDefinition')
        break
      case 3:
        this.setDefaultTourValue(
          component,
          defaultValueEarthMesh,
          'westernmostLongitude',
          1
        )
        this.setDefaultTourValue(
          component,
          defaultValueEarthMesh,
          'easternmostLongitude',
          2
        )
        break
      case 4:
        this.setDefaultTourValue(
          component,
          defaultValueEarthMesh,
          'southernmostLatitude',
          3
        )
        this.setDefaultTourValue(
          component,
          defaultValueEarthMesh,
          'northernmostLatitude',
          4
        )
        break
      case 5:
        this.setDefaultTourValue(
          component,
          defaultValueEarthMesh,
          'numberOfLongitudes',
          5
        )
        this.setDefaultTourValue(
          component,
          defaultValueEarthMesh,
          'numberOfLatitudes',
          6
        )
        component.gt_PerformanceAnalysis.earthMeshDone = true
        break
      default:
        break
    }
  },
  onSkipEarthMesh(component) {
    this.setDefaultTourValue(component, defaultValueEarthMesh, 'name', 0)
    component.inputs['rangeType'] = 'NUMBER'
    component.inputs['elementDefinition'] =
      component.getDefaultValue('elementDefinition')
    this.setDefaultTourValue(
      component,
      defaultValueEarthMesh,
      'westernmostLongitude',
      1
    )
    this.setDefaultTourValue(
      component,
      defaultValueEarthMesh,
      'easternmostLongitude',
      2
    )
    this.setDefaultTourValue(
      component,
      defaultValueEarthMesh,
      'southernmostLatitude',
      3
    )
    this.setDefaultTourValue(
      component,
      defaultValueEarthMesh,
      'northernmostLatitude',
      4
    )
    this.setDefaultTourValue(
      component,
      defaultValueEarthMesh,
      'numberOfLongitudes',
      5
    )
    this.setDefaultTourValue(
      component,
      defaultValueEarthMesh,
      'numberOfLatitudes',
      6
    )
    component.gt_PerformanceAnalysis.earthMeshDone = true
    this.onFinishEarthMesh(component)
  },

  beginConstellationHomogeneousGeometryTour(component) {
    if (component.gt_PerformanceAnalysis.firstGeometryDone) {
      component.$tours['performanceAnalysisTourHomogeneousGeometry'].start(12)
    } else if (component.gt_PerformanceAnalysis.firstPayloadDone) {
      component.$tours['performanceAnalysisTourHomogeneousGeometry'].start(2)
    } else {
      setTimeout(
        () =>
          component.$tours[
            'performanceAnalysisTourHomogeneousGeometry'
          ].start(),
        500
      )
    }
  },
  onNextStepHomogeneousGeometry(currentStep, component) {
    switch (currentStep) {
      case 0:
        this.setDefaultTourValue(
          component,
          defaultValueConstellationGeometry,
          'name',
          0
        )
        break
      case 1:
        if (
          component.inputs.payload === null ||
          component.inputs.payload.length === 0
        ) {
          component.$tours['performanceAnalysisTourHomogeneousGeometry'].start(
            1
          )
        } else {
          component.inputs.firstPayloadDone = true
        }
        break
      case 2:
        component.inputs['constellationType'] = 'WALKER_DELTA'
        break
      case 4:
        component.inputs['planeDefinitionType'] = 'ALTITUDE_AND_INCLINATION'
        break
      case 5:
        this.setDefaultTourValue(
          component,
          defaultValueConstellationGeometry,
          'walkerI',
          1
        )
        break
      case 6:
        this.setDefaultTourValue(
          component,
          defaultValueConstellationGeometry,
          'walkerT',
          2
        )
        break
      case 7:
        this.setDefaultTourValue(
          component,
          defaultValueConstellationGeometry,
          'walkerP',
          3
        )
        break
      case 8:
        this.setDefaultTourValue(
          component,
          defaultValueConstellationGeometry,
          'walkerF',
          4
        )
        break
      case 9:
        this.setDefaultTourValue(
          component,
          defaultValueConstellationGeometry,
          'altitude',
          5
        )
        break
      case 10:
        this.setDefaultTourValue(
          component,
          defaultValueConstellationGeometry,
          'firstPlaneInitialRaan',
          6
        )
        component.gt_PerformanceAnalysis.firstGeometryDone = true
        break
      case 11:
        this.onFinishHomogeneousGeometry(component)
        break
      case 12:
        this.setDefaultTourValue(
          component,
          defaultValueConstellationGeometry,
          'name',
          7
        )
        break
      case 13:
        if (
          component.inputs.payload === null ||
          component.inputs.payload.length === 0
        ) {
          component.$tours['performanceAnalysisTourHomogeneousGeometry'].start(
            13
          )
        }
        break
      case 14:
        component.inputs['constellationType'] = 'WALKER_DELTA'
        break
      case 15:
        component.inputs['planeDefinitionType'] = 'ALTITUDE_AND_SUN_SYNCHRONOUS'
        break
      case 16:
        this.setDefaultTourValue(
          component,
          defaultValueConstellationGeometry,
          'walkerT',
          8
        )
        break
      case 17:
        this.setDefaultTourValue(
          component,
          defaultValueConstellationGeometry,
          'walkerP',
          9
        )
        break
      case 18:
        this.setDefaultTourValue(
          component,
          defaultValueConstellationGeometry,
          'walkerF',
          10
        )
        break
      case 19:
        this.setDefaultTourValue(
          component,
          defaultValueConstellationGeometry,
          'altitude',
          11
        )
        break
      case 20:
        this.setDefaultTourValue(
          component,
          defaultValueConstellationGeometry,
          'firstPlaneInitialRaan',
          6
        )
        component.gt_PerformanceAnalysis.secondGeometryDone = true
        break
      default:
        break
    }
  },
  onSkipHomogeneousGeometry(component) {
    let payloadIndex = component.gt_PerformanceAnalysis.firstGeometryDone
      ? 13
      : 1
    if (component.gt_PerformanceAnalysis.firstGeometryDone) {
      this.setDefaultTourValue(
        component,
        defaultValueConstellationGeometry,
        'name',
        7
      )
      component.inputs['constellationType'] = 'WALKER_DELTA'
      component.inputs['planeDefinitionType'] = 'ALTITUDE_AND_SUN_SYNCHRONOUS'
      this.setDefaultTourValue(
        component,
        defaultValueConstellationGeometry,
        'walkerT',
        8
      )
      this.setDefaultTourValue(
        component,
        defaultValueConstellationGeometry,
        'walkerP',
        9
      )
      this.setDefaultTourValue(
        component,
        defaultValueConstellationGeometry,
        'walkerF',
        10
      )
      this.setDefaultTourValue(
        component,
        defaultValueConstellationGeometry,
        'altitude',
        11
      )
      this.setDefaultTourValue(
        component,
        defaultValueConstellationGeometry,
        'firstPlaneInitialRaan',
        6
      )
      component.gt_PerformanceAnalysis.secondGeometryDone = true
    } else {
      this.setDefaultTourValue(
        component,
        defaultValueConstellationGeometry,
        'name',
        0
      )
      component.inputs['constellationType'] = 'WALKER_DELTA'
      component.inputs['planeDefinitionType'] = 'ALTITUDE_AND_INCLINATION'
      this.setDefaultTourValue(
        component,
        defaultValueConstellationGeometry,
        'walkerI',
        1
      )
      this.setDefaultTourValue(
        component,
        defaultValueConstellationGeometry,
        'walkerT',
        2
      )
      this.setDefaultTourValue(
        component,
        defaultValueConstellationGeometry,
        'walkerP',
        3
      )
      this.setDefaultTourValue(
        component,
        defaultValueConstellationGeometry,
        'walkerF',
        4
      )
      this.setDefaultTourValue(
        component,
        defaultValueConstellationGeometry,
        'altitude',
        5
      )
      this.setDefaultTourValue(
        component,
        defaultValueConstellationGeometry,
        'firstPlaneInitialRaan',
        6
      )
    }
    if (
      component.inputs.payload === null ||
      component.inputs.payload.length === 0
    ) {
      component.$tours['performanceAnalysisTourHomogeneousGeometry'].start(
        payloadIndex
      )
    } else {
      if (component.gt_PerformanceAnalysis.firstGeometryDone) {
        component.gt_PerformanceAnalysis.secondGeometryDone = true
      } else {
        component.gt_PerformanceAnalysis.firstGeometryDone = true
      }
      this.onFinishHomogeneousGeometry(component)
    }
  },

  onNextStepPayload(currentStep, component) {
    switch (currentStep) {
      case 0:
        this.setDefaultTourValue(component, defaultValuePayload, 'name', 0)
        break
      case 1:
        this.setDefaultTourValue(
          component,
          defaultValuePayload,
          'payloadPower',
          1
        )
        break
      case 2:
        this.setDefaultTourValue(
          component,
          defaultValuePayload,
          'semiViewAngleCircularDefinition',
          2
        )
        break
      case 3:
        component.inputs['telecomType'] = 'DEFINED'
        //needed otherwise the component is not always loaded
        setTimeout(
          () => component.$tours['performanceAnalysisTourPayload'].start(4),
          100
        )
        break
      case 4:
        this.setDefaultTourValue(
          component,
          defaultValuePayload,
          'uplinkRate',
          3
        )
        component.gt_PerformanceAnalysis.firstPayloadDone = true
        break
      default:
        break
    }
  },
  onSkipPayload(component) {
    this.setDefaultTourValue(component, defaultValuePayload, 'name', 0)
    this.setDefaultTourValue(component, defaultValuePayload, 'payloadPower', 1)
    this.setDefaultTourValue(
      component,
      defaultValuePayload,
      'semiViewAngleCircularDefinition',
      2
    )
    component.inputs['telecomType'] = 'DEFINED'
    this.setDefaultTourValue(component, defaultValuePayload, 'uplinkRate', 3)
    component.gt_PerformanceAnalysis.firstPayloadDone = true
    this.onFinishPayload(component)
  },

  onNextStepDashboard(currentStep, component) {
    if (currentStep === 0) {
      if (component.displayComputationWidget) {
        component.$tours['performanceAnalysisTourDashboard'].start()
      } else if (currentStep === 0 && component.displayResult) {
        component.$tours['performanceAnalysisTourDashboard'].start(1)
      }
    } else if (currentStep === 4) {
      component.openDashboardSettings()
      component.isGuidedTutorialInDisplaySettings = true
    } else if (currentStep === 8) {
      component.isGuidedTutorialInDisplaySettings = false
      component.updateMap()
    }
  },

  onFinishSubmit(component) {
    if (component.inputsValid) {
      component.submitForm()
    }
  },

  stopAllTours(component) {
    for (const key of Object.keys(component.gt_PerformanceAnalysis)) {
      component.start_gt_PerformanceAnalysis({ param: key, val: false })
    }
    for (const tour in component.$tours) {
      component.$tours[tour].stop()
    }
  }
}
